import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';
import Section from '../../section';
import Container from '../../container';
import FormGrid from '../form-grid';
import Button from '../../button';

const replaceName = (content, user) => {
  if (!content) return null;

  return content.replace(/:name/gm, user);
};

const Account = ({ user, loggedInContent, loggedOutContent }) => (
  <Section styles="padding-bottom: 120px; position: relative;">
    <Container>
      <FormGrid number="01">
        {user
          ?
            <Fragment>
              <h3>{replaceName(loggedInContent.fields.title, user.firstName)}</h3>
              <p>{replaceName(loggedInContent.fields.description, user.firstName)}</p>
            </Fragment>
          :
            <Fragment>
              <h3>{loggedOutContent.fields.title}</h3>
              <p>{loggedOutContent.fields.description}</p>
              <ButtonWrap>
                <AccountButton href="/login">Sign in</AccountButton>
                <AccountButton href="/create-account">Create Account</AccountButton>
              </ButtonWrap>
            </Fragment>
        }
      </FormGrid>
    </Container>
  </Section>
);

const ButtonWrap = styled.div`
  margin-top: 60px;

  a:last-of-type {
    margin-left: 30px;

    ${screen.below(bp.laptop, `
      margin-left: 20px;
    `)}

    ${screen.below(bp.mobile, `
      margin-left: 10px;
    `)}
  }

  ${screen.below(bp.portrait, `
    margin-top: 20px;

    a { width: calc(50% - 10px)};
  `)}

  ${screen.below(bp.mobile, `
    a { width: calc(50% - 5px)};
  `)}
`;

const AccountButton = styled(Button)`
  ${screen.between(bp.portrait, bp.laptopSm, `
    width: 200px;
  `)}
`;

Account.propTypes = {
  user: PropTypes.object,
  loggedInContent: PropTypes.object,
  loggedOutContent: PropTypes.object,
};

Account.defaultProps = {
  loggedInContent: {
    fields: {
      title: 'Hello :name',
      description: 'Let\'s get started',
    },
  },
  loggedOutContent: {
    fields: {
      title: 'Account',
      description: 'Please login to continue.',
    },
  },
};

export default Account;
